import { Route, Routes } from "@angular/router";
import * as _ from "lodash";

import { AuthGuard } from "./guards/auth.guard";

import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { PageNotFoundComponent } from "./components/page-not-found/page-not-found.component";
import { HealthcheckComponent } from "./components/healthcheck/healthcheck.component";
import { FeatureGuard } from "./guards";
import { environment } from "src/environments/environment.uat";
export const appRoutes: Routes = [
  { path: "healthcheck", component: HealthcheckComponent },
  {
    path: "audit",
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature },
    loadChildren: () =>
      import("./modules/audit/audit.module").then((m) => m.AuditModule),
  },
  {
    path: "admin",
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature },
    loadChildren: () =>
      import("./modules/admin/admin.module").then((m) => m.AdminModule),
  },
  {
    path: "metrics",
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature },
    loadChildren: () =>
      import("./modules/rx-audit/rx-audit.module").then((m) => m.RxAuditModule),
  },
  {
    path: "",
    component: LandingPageComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: { feature: environment.applicationApplinkFeature },
  },
  { path: "**", component: PageNotFoundComponent },
];

export function componentFromRoute(route: string): Route {
  const myRoute = _.find(appRoutes, { path: route });
  return myRoute;
}
